module.exports = __webpack_public_path__ + "media/country_flags/cr-787efbc0.png";